module.exports = __webpack_public_path__ + "static/media/logo-main.a6b4ae66.svg";